<script>
import config from '@/assets/js/config.js'
import AppException from '@/utils/AppException'
export default {
  name: 'translate',
  data () {
    return {
    }
  },
  computed: {
    translationLanguages () {
      return this.languages.filter(o => o !== 'Tw').map(o => config.googleLanguageMap[o])
    }
  },
  methods: {
    translateForm (translateKeys) {
      let genPayload = () => {
        var texts = []

        for (var i = 0; i < translateKeys.length; ++i) {
          let key = translateKeys[i]
          if (this.form['Tw'][key]) texts.push(this.form['Tw'][key])
        }

        return {
          'Texts': texts,
          languages: this.translationLanguages
        }
      }
      let onTranslateCompleted = (result) => {
        var i

        var idx = 0
        for (i = 0; i < translateKeys.length; ++i) {
          let key = translateKeys[i]
          if (this.form['Tw'][key]) {
            let langs = this.languages.filter(o => o !== 'Tw')
            for (let lang of langs) {
              let googleLang = config.googleLanguageMap[lang]
              this.$set(this.form[lang], key, result.Texts[googleLang][idx])
            }
            idx += 1
          }
        }
      }
      let payload = genPayload()
      if (!payload.Texts.length) {
        return new Promise((resolve, reject) => {
          resolve(alert('您尚未輸入任何文字至資料表單'))
        })
      }
      return this.$services.translation.translate(this, payload).then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) onTranslateCompleted(res.data.result)
      }).catch(this.$handleServiceError)
    },
    translateContentEditor (contentJsonArr) {
      var textInfos = []

      const htmlToPlainText = html => {
        let tmp = document.createElement('DIV')
        tmp.innerHTML = html
        return tmp.textContent || tmp.innerText || ''
      }

      const genPayload = () => {
        const appendTextInfo = (index, index2, index3, text) => {
          textInfos.push({
            index: index,
            index2: index2,
            index3: index3,
            text: text
          })
        }

        const genContentEditorObjectInfo = (obj, index1, index2) => {
          switch (obj.type) {
            case 'title':
              appendTextInfo(index1, index2, null, obj.value)
              break
            case 'subtitle':
              appendTextInfo(index1, index2, null, obj.value)
              break
            case 'content':
              appendTextInfo(index1, index2, null, htmlToPlainText(obj.value))
              break
            case 'quote':
              appendTextInfo(index1, index2, null, htmlToPlainText(obj.value))
              break
            case 'comment':
              appendTextInfo(index1, index2, null, htmlToPlainText(obj.value))
              break
            case 'link':
              appendTextInfo(index1, index2, null, obj.value.title)
              break
            case 'image':
              if (typeof index2 === 'number') {
                appendTextInfo(index1, index2, 0, obj.value.title)
                appendTextInfo(index1, index2, 1, obj.value.alt)
              } else {
                appendTextInfo(index1, 0, null, obj.value.title)
                appendTextInfo(index1, 1, null, obj.value.alt)
              }
              break
            case 'video':
              appendTextInfo(index1, index2, null, '')
              break
            case 'videofromurl':
              // do not translate
              break
            case 'carousel':
              let items = obj.value.items
              for (var i2 in items) {
                i2 = parseInt(i2)
                let obj2 = items[i2]
                genContentEditorObjectInfo(obj2, index1, i2)
              }
              break
            case 'code':
              appendTextInfo(index1, index2, null, htmlToPlainText(obj.value))
              break
            case 'htmlcode':
              // do not translate
              break
            case 'complex':
              let obj1 = obj.value.value1
              let obj2 = obj.value.value2
              genContentEditorObjectInfo(obj1, index1, 0)
              genContentEditorObjectInfo(obj2, index1, 1)
              break
            default:
              console.error(`unknown contenteditor type`, obj.type, obj)
              break
          }
        }

        for (var i in contentJsonArr) {
          let obj = contentJsonArr[i]
          genContentEditorObjectInfo(obj, i)
        }

        return {
          'Texts': textInfos.map(o => o.text),
          languages: this.translationLanguages
        }
      }

      const setContentEditorObjectInfo = (obj, index2, index3, translatedText) => {
        console.log(`setContentEditorObjectInfo`, obj)
        switch (obj.type) {
          case 'title':
            obj.value = translatedText
            break
          case 'subtitle':
            obj.value = translatedText
            break
          case 'content':
            obj.value = translatedText
            break
          case 'quote':
            obj.value = translatedText
            break
          case 'comment':
            obj.value = translatedText
            break
          case 'link':
            obj.value.title = translatedText
            break
          case 'image':
            if (index2 === 0) obj.value.title = translatedText
            else if (index2 === 1) obj.value.alt = translatedText
            else console.error(`unknown setContentEditorObjectInfo image index2 `, index2)
            break
          case 'video':
            // ignore
            break
          case 'videofromurl':
            // ignore
            break
          case 'carousel':
            let items = obj.value.items
            let item = items[index2]
            console.log(`setContentEditorObjectInfo, type=carousel`, 'index2=', index2, 'index3=', index3, 'item=', item)
            setContentEditorObjectInfo(item, index3, null, translatedText)
            break
          case 'code':
            obj.value = translatedText
            console.log(`code set to `, translatedText)
            break
          case 'htmlcode':
            // ignore
            break
          case 'complex':
            let obj1 = obj.value.value1
            let obj2 = obj.value.value2
            console.log(`setContentEditorObjectInfo, type=complex`, 'index2=', index2, 'index3=', index3, 'obj1=', obj1, 'obj2=', obj2)
            if (index2 === 0) setContentEditorObjectInfo(obj1, index3, null, translatedText)
            else if (index2 === 1) setContentEditorObjectInfo(obj2, index3, null, translatedText)
            else console.error(`unknown setContentEditorObjectInfo complex index2 `, index2)
            break
          default:
            console.error(`unknown contenteditor type`, obj.type, obj)
            break
        }
      }

      const genTranslatedContentEditor = (old, textInfos, translatedTexts) => {
        var contentJsonArr = JSON.parse(JSON.stringify(old))
        if (textInfos.length !== translatedTexts.length) {
          console.error(`錯誤，翻譯後的內容不匹配`, textInfos, translatedTexts)
          throw new AppException('錯誤，翻譯後的內容不匹配')
        }

        for (let i in textInfos) {
          let textInfo = textInfos[i]
          let translatedText = translatedTexts[i]
          var obj = contentJsonArr[textInfo.index]

          if (translatedText === '') continue // 沒有內容就略過，例如影片

          try {
            console.log(`setContentEditorObjectInfo, i = ${i}`, 'textInfo=', textInfo, 'obj=', obj)
            setContentEditorObjectInfo(obj, textInfo.index2, textInfo.index3, translatedText)
          } catch (err) {
            console.error(err)
          }
        }
        return contentJsonArr
      }
      let onTranslateCompleted = (result) => {
        let langs = this.languages.filter(o => o !== 'Tw')
        for (let lang of langs) {
          let googleLang = config.googleLanguageMap[lang]
          this.$set(this.form[lang], 'contentJsonArr', [])
          this.$set(this.form[lang], 'contentJsonArr', genTranslatedContentEditor(contentJsonArr, textInfos, result.Texts[googleLang]))
        }
      }
      let payload = genPayload()
      if (!payload.Texts.length) {
        return new Promise((resolve, reject) => {
          resolve(alert('您尚未輸入任何內容至編輯器'))
        })
      }
      return this.$services.translation.translate(this, payload).then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) onTranslateCompleted(res.data.result)
      }).catch(this.$handleServiceError)
    },
    syncForm (syncKeys) {
      const syncValue = (key) => {
        let langs = this.languages.filter(o => o !== 'Tw')
        for (let lang of langs) {
          this.$set(this.form[lang], key, this.form['Tw'][key])
        }
      }

      var i
      for (i = 0; i < syncKeys.length; ++i) {
        let key = syncKeys[i]
        if (this.form['Tw'][key]) syncValue(key)
      }
      syncValue('IsActive')
    }
  },
  created () {
  }
}
</script>
